import { render } from "./RemoveDuplicates.vue?vue&type=template&id=425e169a&scoped=true"
import script from "./RemoveDuplicates.vue?vue&type=script&lang=js"
export * from "./RemoveDuplicates.vue?vue&type=script&lang=js"

import "./RemoveDuplicates.vue?vue&type=style&index=0&id=425e169a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425e169a"]])

export default __exports__